module.exports = __webpack_public_path__ + "img/login-left-2.254ec321.jpg";